module.exports = __webpack_public_path__ + "static/media/Left_Leg.6f616dfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/position_icons/Left_Leg.svg
// module id = 750
// module chunks = 0